module.exports = __webpack_public_path__ + "video/900_HC_2023_Phishing_Email_Exercise.6cffd77f.vtt";